import React from 'react';

import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createBrowserHistory } from 'history';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';

import App from './App';
import './i18n';
import './index.css';
import store from './store/store';
import { env } from './utils/env';
import { queryClient } from './utils/queryClient';
import { theme } from './utils/theme';

export const history = createBrowserHistory({
  basename: env.PUBLIC_URL,
});

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
          <Toaster position="bottom-center" />
          <ReactQueryDevtools initialIsOpen={false} />
        </ThemeProvider>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
);
